import axios from "axios";
import { refreshToken } from "./authService";
import { store } from "../redux/store";
// const getApiUrl = () => {
//   if (window.location.hostname === "localhost") {
//     return "http://localhost:8800/api/";
//   }
//   // console.log(window.location.hostname);
//   return `http://${window.location.hostname}:8800/api/`;
// };

const getApiUrl = () => {
  // Fallback for local dev
  if (window.location.hostname === "localhost") {
    return process.env.REACT_APP_LOCAL_API_URL;
  }

  // Prefer environment variable if set
  return process.env.REACT_APP_API_URL;
};

const axiosInstance = axios.create({
  // baseURL: process.env.REACT_APP_API_URL,
  baseURL: getApiUrl(),
  withCredentials: true,
});

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response, // pass through success
  async (error) => {
    const originalRequest = error.config;
    const state = store.getState();

    // 🚫 Do not refresh if user has logged out
    if (state.user.isLoggedOut) {
      return Promise.reject(error);
    }

    // If 401 and not already retried
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await refreshToken(); // refresh access token
        return axiosInstance(originalRequest); // retry original request
      } catch (refreshError) {
        // If refresh fails, redirect to login or handle gracefully
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
